import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import useNovidades from '../hooks/useNovidades';

// Popup de novidades: abre ao entrar enquanto houver novidade não lida.
// "Marcar como lida" (em cada uma) e "Já li todas" gravam no servidor. "Ver depois" só
// fecha nesta sessão: as não lidas voltam no próximo acesso.
const CHAVE_VER_DEPOIS = 'novidadesVerDepois';
const MAX_NO_POPUP = 3;

export default function NovidadesPopup() {
  const { naoLidas, marcar } = useNovidades();
  const [verDepois, setVerDepois] = useState(() => sessionStorage.getItem(CHAVE_VER_DEPOIS) === 'true');

  // Na própria página de Novidades o popup só atrapalharia (ex.: ao marcar uma como não lida).
  const naPaginaDeNovidades = useLocation().pathname === '/novidades';
  const aberto = naoLidas.length > 0 && !verDepois && !naPaginaDeNovidades;

  const adiar = () => {
    sessionStorage.setItem(CHAVE_VER_DEPOIS, 'true');
    setVerDepois(true);
  };

  return (
    <Modal show={aberto} onHide={adiar} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="h5">
          <i className="fas fa-newspaper text-primary mr-2" aria-hidden="true" />
          {naoLidas.length === 1 ? 'Há uma novidade no sistema' : `Há ${naoLidas.length} novidades no sistema`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="list-unstyled mb-0">
          {naoLidas.slice(0, MAX_NO_POPUP).map((n) => (
            <li key={n.id} className="border-left-primary border rounded px-3 py-2 mb-3">
              <div className="small text-muted">{format(parseISO(n.data), 'dd/MM/yyyy')}</div>
              <div className="font-weight-bold text-gray-800">{n.titulo}</div>
              <div className="small text-gray-800">{n.resumo}</div>
              <button type="button" className="btn btn-link btn-sm p-0 mt-1" onClick={() => marcar([n.id], true)}>
                <i className="fas fa-check mr-1" aria-hidden="true" />
                Marcar como lida
              </button>
            </li>
          ))}
        </ul>
        {naoLidas.length > MAX_NO_POPUP && (
          <p className="small text-muted mb-0">{`E mais ${naoLidas.length - MAX_NO_POPUP} na página de novidades.`}</p>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Link to="/novidades" onClick={adiar} className="small">Ver detalhes e como usar</Link>
        <div>
          <Button variant="outline-secondary" className="mr-2" onClick={adiar}>Ver depois</Button>
          <Button variant="primary" onClick={() => marcar(naoLidas.map((n) => n.id), true)}>
            {naoLidas.length === 1 ? 'Já li' : 'Já li todas'}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
